import { MethodTypeRepository } from '@telespot/domain';

export interface IDeleteMethodTypeCommand {
  /**
   * Deletes the method type with the given id.
   * Repository errors propagate so callers can decide how to react.
   */
  execute(methodTypeId: string): Promise<void>;
}

export class DeleteMethodTypeCommand implements IDeleteMethodTypeCommand {
  constructor(private readonly methodTypeRepository: MethodTypeRepository) {}

  public async execute(methodTypeId: string): Promise<void> {
    await this.methodTypeRepository.delete(methodTypeId);
  }
}
